const REPORT_STORAGE_PREFIX = 'growth-active-report'
const REPORT_LOCK_PREFIX = 'growth-active-report-lock'
const REPORT_LOCK_TTL = 1000 * 60
const REPORT_PLATFORM = 'web'

let isReporting = false

const getToday = () => dayjs().format('YYYY-MM-DD')

const getReportKeys = (uid) => {
  const today = getToday()
  return {
    storageKey: `${REPORT_STORAGE_PREFIX}:${uid}:${today}`,
    lockKey: `${REPORT_LOCK_PREFIX}:${uid}:${today}`,
  }
}

const hasActiveLock = (lockKey) => {
  const lockTime = Number(localStorage.getItem(lockKey))
  return lockTime > 0 && Date.now() - lockTime < REPORT_LOCK_TTL
}

export const reportGrowthActiveOnce = async () => {
  const userStore = useUserStore()
  const uid = userStore.info?.uid

  if (!userStore.token || !uid || isReporting) {
    return
  }

  const { storageKey, lockKey } = getReportKeys(uid)

  if (localStorage.getItem(storageKey) || hasActiveLock(lockKey)) {
    return
  }

  isReporting = true
  localStorage.setItem(lockKey, `${Date.now()}`)

  try {
    const { execute } = userApi.growthActiveReport({ platform: REPORT_PLATFORM })
    await execute()
    localStorage.setItem(storageKey, '1')
  } catch (error) {
    console.log('growth active report failed', error)
  } finally {
    localStorage.removeItem(lockKey)
    isReporting = false
  }
}
